module.exports = __webpack_public_path__ + "static/s5-icons-5ded3f24db2c3d043633504570ce6ff4.png";